
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";

export const useSubscriptionDialog = (user: User | null) => {
  const [showRequiredPlan, setShowRequiredPlan] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState("");
  const [isUnpaid, setIsUnpaid] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('avatar_url, first_name, last_name, subscription_plan, subscription_status, subscription_end_date')
          .eq('id', user?.id)
          .maybeSingle();
          
        if (error) throw error;
        
        if (data) {
          setAvatarUrl(data.avatar_url || "");
          
          const currentDate = new Date();
          const endDate = data.subscription_end_date ? new Date(data.subscription_end_date) : null;
          
          // Show dialog and set message type based on subscription status
          if (data.subscription_status === 'past_due') {
            // Case 1: Payment required
            setShowRequiredPlan(true);
            setIsUnpaid(true);
          } else if (data.subscription_status === 'canceled' && endDate && endDate < currentDate) {
            // Case 2: Canceled subscription past end date
            setShowRequiredPlan(true);
            setIsUnpaid(false);
          } else if (
            (data.subscription_plan === 'trial' && endDate && endDate < currentDate) ||
            (data.subscription_plan === 'free' && endDate && endDate < currentDate)
          ) {
            // Case 3: Trial ended
            setShowRequiredPlan(true);
            setIsUnpaid(false);
          } else {
            setShowRequiredPlan(false);
            setIsUnpaid(false);
          }
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    
    if (user) {
      fetchProfile();
    }
  }, [user]);

  return { showRequiredPlan, avatarUrl, isUnpaid };
};
